import { defineMessages } from 'react-intl';

export const commonMessages = defineMessages({
  noInfo: {
    id: 'noInfo',
    defaultMessage: 'No Information.',
    description: 'No Information',
  },
  selectComponentNoOptions: {
    id: 'selectComponent.noOptions',
    defaultMessage: 'No options available',
    description: 'No options available',
  },
  designObligation: {
    id: 'designObligation',
    defaultMessage: 'Design Obligation',
    description: 'Design Obligation',
  },
  maturityStage: {
    id: 'maturityStage',
    defaultMessage: 'Maturity Stage',
    description: 'Maturity Stage',
  },
  buildingBlock: {
    id: 'buildingBlock',
    defaultMessage: 'Building Block',
    description: 'Building Block',
  },
  buildingBlocks: {
    id: 'buildingBlocks',
    defaultMessage: `{number, plural,
      =1 {# Building Block}
      other {# Building Blocks}
    }`,
    description: 'Building Blocks plural form',
  },
  groupBy: {
    id: 'groupBy',
    defaultMessage: 'Group by:',
    description: 'Group by',
  },
  servicePortal: {
    id: 'servicePortal',
    defaultMessage: 'myIT Service Portal',
    description: 'Service Portal name',
  },
});
